<div
    class="info-popup-v2 info-popup-v2--information-v2"
    [attr.role]="notification.role"
    [attr.aria-live]="notification.ariaLive">
    <div class="info-popup-v2__type">
        <span class="info-popup-v2__icon icon icon-circle-warning"></span>
    </div>

    <div class="info-popup-v2__title">
        {{ title | translate }}
    </div>

    <div class="info-popup-v2__text">
        <ng-container *ngIf="notification.translate">
            <p innerHtml=" {{ message | translate }}"></p>
        </ng-container>
        <ng-container *ngIf="!notification.translate">
            <ng-container
                *ngIf="notification.translations.length > 0 && (notification | translateObjectField: 'message':locale)">
                {{ notification | translateObjectField: 'message':locale }}
            </ng-container>
            <ng-container
                *ngIf="
                    notification.translations.length > 0 && !(notification | translateObjectField: 'message':locale)
                ">
                {{ notification.message ? notification.message : '' }}
            </ng-container>
            <ng-container *ngIf="notification.translations.length === 0">
                {{ notification.message }}
            </ng-container>
        </ng-container>
    </div>
</div>
